import React from "react";
import MaskedInput from 'react-text-mask';
import { MetricUtility } from "../../../utilities/MetricUtility";
import { FieldProps } from "../../../models/fields/field-props";
import { FieldHeader } from "../../Common/FieldHeader";

export class RecruitHeightField extends React.PureComponent<FieldProps<number>> {

    constructor(props: FieldProps<number>) {
        super(props);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onBlur(event: React.FocusEvent<HTMLInputElement>) {
        const { onBlur, id, value } = this.props;
        onBlur(id, value);
    }

    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { onChange, id } = this.props;
        onChange(id, MetricUtility.heightToNumber(event.target.value));
    }

    render() {
        const { name, valid, value, required, description } = this.props;
        const maskedValue = value ? MetricUtility.convertHeight(value).toString() : '';
        const className = 'w-100 k-textbox' + (valid ? '' : ' k-state-invalid');
        return <React.Fragment>
            <FieldHeader required={required} name={name} description={description} />
            <MaskedInput
                mask={MetricUtility.maskHeight}
                className={className}
                guide={true}
                onBlur={this.onBlur}
                onChange={this.onChange}
                value={maskedValue}
            />
        </React.Fragment>;
    }
}